import { render, staticRenderFns } from "./CopyToWorkspace.vue?vue&type=template&id=c4405b92&scoped=true&"
import script from "./CopyToWorkspace.vue?vue&type=script&lang=js&"
export * from "./CopyToWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./CopyToWorkspace.vue?vue&type=style&index=0&id=c4405b92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4405b92",
  null
  
)

export default component.exports